$(document).ready(function() {
    section2();
});

$(window).scroll(function() {
    section2();
});

function section2() {
    $section2 = $('#support-section-2 .desktop');
    $section2.each(function() {
        if (visiblePercent($(this)) > 40) {
            if (!$(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        }
    });

    $section2_m = $('#support-section-2 .mobile');
    $section2_m.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        }
        else {
            if ($(this).find('.aos-init').hasClass('aos-animate')) {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        }
    });
}

$('#support-section-3 .service').on('click', function() {
    window.location.href = $(this).data('url');
});

$('#product-support-section-2 .service').on('click', function() {
    window.location.href = $(this).data('url');
});